export const tr = {
    accept: 'Ekle',
    cancel: 'İptal',
    'error-text': 'Lütfen, daha sonra tekrar deneyin',
    'imageAd-help-text': 'Birden fazla reklam oluşturmak için birkaç görsel seçin',
    'textImageAd-help-text': 'Reklam için görsel seçin',
    title: 'Galeri'
};
